module.exports = __webpack_public_path__ + "static/media/mta-02.24bffaab.png";